import { render, staticRenderFns } from "./profile_content.vue?vue&type=template&id=be0fd686"
import script from "./profile_content.vue?vue&type=script&lang=js"
export * from "./profile_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports